import { IotMapDisplayMode } from '@iot-platform/models/maps';
import * as Leaflet from 'leaflet';
import { get } from 'lodash';

export interface I4BMapLayerConfig {
  path: string;
  displayMode: IotMapDisplayMode;
  layer: { [name: string]: Leaflet.LayerGroup };
  options?: { [key: string]: unknown };
}

export interface I4BMapLayersConfig {
  [concept: string]: I4BMapLayerConfig[];
}

export class MapLayersHelper {
  private static LAYERS_CONFIG: I4BMapLayersConfig = {
    sites: [
      { path: 'default', displayMode: 'default', layer: { Basic: Leaflet.layerGroup([]) } },
      { path: 'assetsDevices', displayMode: 'assetsDevices', layer: { 'Assets & Devices': Leaflet.layerGroup([]) } },
      { path: 'activeEvents', displayMode: 'activeEvents', layer: { 'Active Events': Leaflet.layerGroup([]) } },
      { path: 'matchScore', displayMode: 'matchScore', layer: { 'Address Accuracy': Leaflet.layerGroup([]) } }
    ],
    assets: [
      { path: 'default', displayMode: 'default', layer: { Basic: Leaflet.layerGroup([]) } },
      {
        path: 'LEVEL',
        displayMode: 'assetVariable',
        layer: { Level: Leaflet.layerGroup([]) },
        options: { variableName: 'level' }
      },
      {
        path: 'PRESSURE',
        displayMode: 'assetVariable',
        layer: { Pressure: Leaflet.layerGroup([]) },
        options: { variableName: 'pressure' }
      },
      {
        path: 'SHUTDOWN_STATUS',
        displayMode: 'assetVariable',
        layer: { 'Shutdown status': Leaflet.layerGroup([]) },
        options: { variableName: 'shutdown_status' }
      },
      {
        path: 'PRODUCTION_VALVE',
        displayMode: 'assetVariable',
        layer: { 'Production valve': Leaflet.layerGroup([]) },
        options: { variableName: 'production_valve' }
      },
      {
        path: 'LEFT_PRESSURE',
        displayMode: 'assetVariable',
        layer: { 'Left pressure': Leaflet.layerGroup([]) },
        options: { variableName: 'left_pressure' }
      },
      {
        path: 'RIGHT_PRESSURE',
        displayMode: 'assetVariable',
        layer: { 'Right pressure': Leaflet.layerGroup([]) },
        options: { variableName: 'right_pressure' }
      }
    ],
    devices: [
      { path: 'default', displayMode: 'default', layer: { Basic: Leaflet.layerGroup([]) } },
      { path: 'ccf', displayMode: 'ccf', layer: { CCF: Leaflet.layerGroup([]) } },
      {
        path: 'SQ',
        displayMode: 'deviceVariable',
        layer: { 'Radio level (3G+)': Leaflet.layerGroup([]) },
        options: { variableName: 'SQ' }
      },
      {
        path: 'rl',
        displayMode: 'deviceVariable',
        layer: { 'Radio level (2G)': Leaflet.layerGroup([]) },
        options: { variableName: 'rl' }
      }
    ]
  };

  public static getLayersByConcept(concept: string | null): { [layerName: string]: Leaflet.LayerGroup } {
    return (get(this.LAYERS_CONFIG, concept, []) as I4BMapLayerConfig[]).reduce(
      (
        acc: {
          [layerName: string]: Leaflet.LayerGroup;
        },
        config: I4BMapLayerConfig
      ) => {
        Object.entries(config.layer).forEach(([lName, layer]) => {
          acc[lName] = layer;
        });
        return acc;
      },
      {}
    );
  }

  public static getSelectedLayerConfig(concept: string | null, layerName: string): I4BMapLayerConfig | undefined {
    return get(this.LAYERS_CONFIG, concept, []).find((config: I4BMapLayerConfig) => Object.keys(config.layer).includes(layerName));
  }

  public static getDisplayModeByLayer(concept: string | null, layerName: string): IotMapDisplayMode {
    const config = this.getSelectedLayerConfig(concept, layerName);
    return config?.displayMode ? config.displayMode : 'default';
  }
}
